/* Scoped styles for the WooCommerce widget */
#silfra-chat-widget-container {
  --color-primary: #005eb8;
  --color-primary-light: #3a82cd;
  --color-primary-dark: #004a93;
  --color-surface: #ffffff;
  --color-background: #f4f6f8;
  --color-text: #1a1a1a;
  --color-text-light: #ffffff;
  --color-border: #e1e8ed;
  --color-success: #10b981;
  --color-sale: #ef4444;

  --fs-xs: 11px;
  --fs-sm: 13px;
  --fs-md: 15px;
  --fs-lg: 17px;

  --font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
  --line-height: 1.5;
  --font-weight: 400;

  font-family: var(--font-family) !important;
  line-height: var(--line-height) !important;
  font-weight: var(--font-weight) !important;
  color: var(--color-text) !important;
  text-align: left !important;
  font-size: 16px !important;
  direction: ltr !important;

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  z-index: 2147483647 !important;
  position: relative !important;
}

/* Reset */
#silfra-chat-widget-container *,
#silfra-chat-widget-container *::before,
#silfra-chat-widget-container *::after {
  box-sizing: border-box !important;
  outline: none;
}

:where(#silfra-chat-widget-container)
  :where(
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    ul,
    li,
    figure,
    blockquote,
    dl,
    dd,
    div,
    span,
    a
  ) {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  font-family: inherit;
  font-weight: inherit;
}

/* #silfra-chat-widget-container h1,
#silfra-chat-widget-container h2,
#silfra-chat-widget-container h3,
#silfra-chat-widget-container h4,
#silfra-chat-widget-container h5,
#silfra-chat-widget-container h6,
#silfra-chat-widget-container p,
#silfra-chat-widget-container ul,
#silfra-chat-widget-container li,
#silfra-chat-widget-container figure,
#silfra-chat-widget-container blockquote,
#silfra-chat-widget-container dl,
#silfra-chat-widget-container dd,
#silfra-chat-widget-container div,
#silfra-chat-widget-container span,
#silfra-chat-widget-container a {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  font-family: inherit;
  font-weight: inherit;
} */

#silfra-chat-widget-container button {
  background: none;
  border: none;
  font: inherit;
  cursor: pointer;
  padding: 0;
  color: inherit;
  appearance: none;
  -webkit-appearance: none;
  box-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  pointer-events: auto !important;
}

#silfra-chat-widget-container input,
#silfra-chat-widget-container textarea {
  font-family: inherit;
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  pointer-events: auto !important;
}

#silfra-chat-widget-container a {
  pointer-events: auto !important;
}

/* --- Floating Button --- */
#silfra-chat-widget-container .xpert-floating-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2147483646;
  pointer-events: auto !important;
}

#silfra-chat-widget-container .xpert-floating-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

/* --- Panel --- */
#silfra-chat-widget-container .xpert-panel {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 400px;
  height: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 2147483646;
  pointer-events: auto !important;
}

#silfra-chat-widget-container .xpert-panel.wide {
  width: 500px;
}

/* Mobile sizing for the panel lives in the consolidated mobile section at the
   end of this file, so it can also override .xpert-panel.wide (which has
   higher specificity than a bare .xpert-panel rule). */

/* --- Home Screen --- */
#silfra-chat-widget-container .xpert-home-screen {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
  overflow-y: auto;
}

#silfra-chat-widget-container .xpert-profile-card {
  background: #ffffff;
  color: var(--color-text);
  margin: 1rem 1rem 0.5rem 1rem;
  border-radius: 14px;
  position: relative;
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.08);
  overflow: hidden;
}

/* The home/welcome screen is a scrolling flex column. Without this the card
   (overflow: hidden → min-height 0) is squeezed to 0px on short panels and the
   "Welcome to MiraQ Shopper" header with expand/close disappears. */
#silfra-chat-widget-container .xpert-home-screen > .xpert-profile-card {
  flex-shrink: 0;
}

#silfra-chat-widget-container .xpert-profile-card .xpert-profile-card-info {
  padding: 1rem 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Slim gradient bar under the header card — the widget's signature accent */
#silfra-chat-widget-container .xpert-profile-accent {
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
}

/* Vertical rule separating the brand text from the controls cluster
   (AI toggle / expand / close) — stretches to the row's full height. */
#silfra-chat-widget-container .xpert-profile-divider {
  align-self: stretch;
  width: 1px;
  background: var(--color-border);
  flex-shrink: 0;
}

#silfra-chat-widget-container .xpert-profile-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

#silfra-chat-widget-container .xpert-profile-info {
  flex: 1;
  min-width: 0;
}

#silfra-chat-widget-container .xpert-profile-label {
  font-size: var(--fs-xs);
  color: #6b7280;
  margin-bottom: 0;
}

#silfra-chat-widget-container .xpert-profile-name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: 1.2;
}

#silfra-chat-widget-container .xpert-profile-sub {
  font-size: var(--fs-xs);
  color: #6b7280;
  margin-top: 0.15rem;
  margin-bottom: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Icon buttons sitting on the now-white header card need the dark-on-white
   treatment; .xpert-icon-btn's base rule is tuned for the colored chat
   header (ChatHeader.tsx, ProductDetailPanel.tsx, etc.) and stays
   untouched there — this only wins inside the profile card via specificity. */
#silfra-chat-widget-container .xpert-profile-card .xpert-icon-btn {
  background: transparent;
  color: var(--color-primary);
  padding: 4px;
}

#silfra-chat-widget-container .xpert-profile-card .xpert-icon-btn:hover {
  background: rgba(0, 94, 184, 0.08);
}

#silfra-chat-widget-container .xpert-ready-badge {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: var(--fs-xs);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

#silfra-chat-widget-container .xpert-main-content {
  background: white;
  margin: 0 1rem 1rem 1rem;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  flex: 1;
  display: flex;
  flex-direction: column;
}

#silfra-chat-widget-container .xpert-content-title {
  font-size: var(--fs-md);
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

#silfra-chat-widget-container .xpert-content-desc {
  font-size: var(--fs-sm);
  color: #666;
  margin-bottom: 1.5rem;
  line-height: 1.4;
}

#silfra-chat-widget-container .xpert-features-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

#silfra-chat-widget-container .xpert-feature-item {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

#silfra-chat-widget-container .xpert-feature-icon {
  font-size: 19px;
  margin-top: 2px;
}

#silfra-chat-widget-container .xpert-feature-text {
  font-size: var(--fs-sm);
  margin-top: 5px;
  color: #444;
  line-height: 1.4;
}

#silfra-chat-widget-container .xpert-bottom-actions {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: stretch;
}

#silfra-chat-widget-container .xpert-bottom-actions.single-button {
  align-items: flex-end;
}

#silfra-chat-widget-container .xpert-start-chat-btn {
  width: 100%;
  padding: 1rem;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

#silfra-chat-widget-container .xpert-start-chat-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

/* --- Welcome screen (components/WelcomeScreen.tsx) --- */
#silfra-chat-widget-container .xpert-welcome-section {
  margin-bottom: 1rem;
}

#silfra-chat-widget-container .xpert-welcome-section-title {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: #333;
  margin: 0 0 0.5rem;
}

/* One horizontally scrolling row; snaps so a swipe on mobile lands on a card. */
#silfra-chat-widget-container .xpert-welcome-products {
  list-style: none;
  margin: 0;
  padding: 2px 2px 6px;
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: thin;
}

#silfra-chat-widget-container .xpert-welcome-products > li {
  flex: 0 0 auto;
  margin: 0;
  scroll-snap-align: start;
}

#silfra-chat-widget-container .xpert-welcome-product {
  width: 112px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  text-align: left;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#silfra-chat-widget-container .xpert-welcome-product:hover {
  border-color: var(--color-primary-light);
  box-shadow: 0 2px 8px rgba(0, 94, 184, 0.12);
}

#silfra-chat-widget-container .xpert-welcome-product:focus-visible,
#silfra-chat-widget-container .xpert-welcome-continue:focus-visible,
#silfra-chat-widget-container .xpert-welcome-new-chat:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

#silfra-chat-widget-container .xpert-welcome-product-img {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-background);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

#silfra-chat-widget-container .xpert-welcome-product-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

#silfra-chat-widget-container .xpert-welcome-sale {
  position: absolute;
  top: 4px;
  left: 4px;
  padding: 1px 5px;
  border-radius: 4px;
  background: var(--color-sale);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

#silfra-chat-widget-container .xpert-welcome-product-name {
  font-size: 12px;
  line-height: 1.3;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

#silfra-chat-widget-container .xpert-welcome-product-price {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-welcome-continue {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  margin-bottom: 1rem;
  text-align: left;
  background: #f8fafc;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

#silfra-chat-widget-container .xpert-welcome-continue:hover {
  border-color: var(--color-primary-light);
  background: #f1f6fc;
}

#silfra-chat-widget-container .xpert-welcome-continue-icon {
  flex: 0 0 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 94, 184, 0.1);
  color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-welcome-continue-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

#silfra-chat-widget-container .xpert-welcome-continue-title {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: #333;
}

#silfra-chat-widget-container .xpert-welcome-continue-preview {
  font-size: 12.5px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#silfra-chat-widget-container .xpert-welcome-continue-time {
  font-size: var(--fs-xs);
  color: #888;
}

#silfra-chat-widget-container .xpert-welcome-chevron {
  flex: 0 0 auto;
  color: #999;
}

/* Buy again */
#silfra-chat-widget-container .xpert-welcome-section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

#silfra-chat-widget-container .xpert-welcome-section-head .xpert-welcome-section-title {
  margin: 0;
}

#silfra-chat-widget-container .xpert-welcome-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-primary);
  white-space: nowrap;
}

#silfra-chat-widget-container .xpert-welcome-link:hover {
  text-decoration: underline;
}

#silfra-chat-widget-container .xpert-welcome-buy-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  overflow: hidden;
}

#silfra-chat-widget-container .xpert-welcome-buy-row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.55rem 0.65rem;
  margin: 0;
  background: var(--color-surface);
}

#silfra-chat-widget-container .xpert-welcome-buy-row + .xpert-welcome-buy-row {
  border-top: 1px solid var(--color-border);
}

#silfra-chat-widget-container .xpert-welcome-buy-img {
  flex: 0 0 44px;
  height: 44px;
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-background);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

#silfra-chat-widget-container .xpert-welcome-buy-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

#silfra-chat-widget-container .xpert-welcome-buy-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

#silfra-chat-widget-container .xpert-welcome-buy-name {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#silfra-chat-widget-container .xpert-welcome-buy-variant {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#silfra-chat-widget-container .xpert-welcome-buy-price {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-welcome-buy-note {
  font-size: 11.5px;
  color: #b45309;
}

#silfra-chat-widget-container .xpert-welcome-buy-btn {
  flex: 0 0 auto;
  min-width: 64px;
  min-height: 32px;
  padding: 0 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  background: var(--color-primary);
  color: #fff;
  transition: background-color 0.15s ease;
}

#silfra-chat-widget-container .xpert-welcome-buy-btn:hover:not(:disabled) {
  background: var(--color-primary-dark);
}

#silfra-chat-widget-container .xpert-welcome-buy-btn:disabled {
  opacity: 0.65;
  cursor: default;
}

#silfra-chat-widget-container .xpert-welcome-buy-btn--ghost {
  background: transparent;
  color: var(--color-primary);
  border: 1px solid var(--color-primary-light);
}

#silfra-chat-widget-container .xpert-welcome-buy-btn--ghost:hover:not(:disabled) {
  background: rgba(0, 94, 184, 0.06);
}

#silfra-chat-widget-container .xpert-welcome-buy-btn--done {
  background: transparent;
  color: var(--color-success);
}

#silfra-chat-widget-container .xpert-welcome-buy-btn:focus-visible,
#silfra-chat-widget-container .xpert-welcome-link:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

#silfra-chat-widget-container .xpert-welcome-new-chat {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* Skeleton while /chat/welcome loads */
#silfra-chat-widget-container .xpert-skel {
  border-radius: 8px;
  background: linear-gradient(90deg, #eef1f4 25%, #f7f9fa 50%, #eef1f4 75%);
  background-size: 200% 100%;
  animation: xpert-skel-shimmer 1.2s ease-in-out infinite;
}

#silfra-chat-widget-container .xpert-skel-line {
  height: 12px;
  margin-bottom: 0.6rem;
}

#silfra-chat-widget-container .xpert-skel-card {
  flex: 0 0 112px;
  height: 150px;
  border-radius: 10px;
}

#silfra-chat-widget-container .xpert-skel-block {
  height: 64px;
  margin: 0.5rem 0 1rem;
  border-radius: 10px;
}

@keyframes xpert-skel-shimmer {
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
}

@media (prefers-reduced-motion: reduce) {
  #silfra-chat-widget-container .xpert-skel {
    animation: none;
  }
}

/* --- Chat Window --- */
/* flex:1 rather than height:100%: the panel is a flex column whose last child
   is now the "Powered by MiraQ" bar. A screen root claiming the full height
   would push that bar past the panel's overflow:hidden edge and hide it. */
#silfra-chat-widget-container .xpert-chat-window {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  background-color: white;
}

#silfra-chat-widget-container .xpert-chat-header {
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white;
  padding: 0.8rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  height: auto;
  min-height: 50px;
}

#silfra-chat-widget-container .xpert-icon-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

#silfra-chat-widget-container .xpert-icon-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

#silfra-chat-widget-container .xpert-header-login-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: var(--fs-xs);
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
  transition: background 0.2s;
}

#silfra-chat-widget-container .xpert-header-login-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  color: white;
}

#silfra-chat-widget-container .xpert-chat-header-info {
  flex: 1;
}

#silfra-chat-widget-container .xpert-chat-header-title {
  font-weight: 600;
  font-size: var(--fs-md);
  margin: 0;
  line-height: normal;
}

#silfra-chat-widget-container .xpert-chat-header-sub {
  font-size: var(--fs-xs);
  opacity: 0.9;
  margin: 0;
  line-height: normal;
}

#silfra-chat-widget-container .xpert-cart-badge {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

#silfra-chat-widget-container .xpert-cart-count {
  position: absolute;
  top: -6px;
  right: -6px;
  background: var(--color-sale);
  color: white;
  font-size: 10px;
  font-weight: 700;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

#silfra-chat-widget-container .xpert-chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background-color: #f9fafb;
}

#silfra-chat-widget-container .xpert-message-row {
  display: flex;
  gap: 0.25rem;
  align-items: flex-start;
}

#silfra-chat-widget-container .xpert-message-row.user {
  flex-direction: row-reverse;
}

#silfra-chat-widget-container .xpert-bot-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 19px;
  margin-top: 0.75rem;
}

#silfra-chat-widget-container .xpert-user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #6b7280;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 19px;
}

#silfra-chat-widget-container .xpert-user-message-wrapper {
  display: flex;
  min-width: 0;
  max-width: 100%;
}

#silfra-chat-widget-container .xpert-message-content {
  flex: 1;
  max-width: 80%;
}

#silfra-chat-widget-container .xpert-message-bubble {
  padding: 0.75rem 0.5rem;
  border-radius: 12px;
  line-height: 1.5;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

#silfra-chat-widget-container .xpert-message-row.bot .xpert-message-bubble {
  flex: 1;
}

#silfra-chat-widget-container .xpert-message-row.user .xpert-message-bubble {
  background: var(--color-primary);
  color: white;
  border-bottom-right-radius: 4px;
}

#silfra-chat-widget-container
  .xpert-message-row.assistant
  .xpert-message-bubble {
  background: white;
  color: #1f2937;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

#silfra-chat-widget-container .xpert-bubble-content {
  font-size: var(--fs-sm);
  word-wrap: break-word;
}

#silfra-chat-widget-container .xpert-bubble-content p {
  margin-bottom: 0.5rem;
}

#silfra-chat-widget-container .xpert-bubble-content p:last-child {
  margin-bottom: 0;
}

/* --- Product Grid --- */
#silfra-chat-widget-container .xpert-product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  margin-top: 0.75rem;
}

#silfra-chat-widget-container .xpert-product-card {
  background: white;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
}

#silfra-chat-widget-container .xpert-product-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

#silfra-chat-widget-container .xpert-product-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  background: #f3f4f6;
}

#silfra-chat-widget-container .xpert-product-info {
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

#silfra-chat-widget-container .xpert-product-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 1.3;
}

#silfra-chat-widget-container .xpert-product-price {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-top: 0.25rem;
}

#silfra-chat-widget-container .xpert-price {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-price-sale {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-sale);
}

#silfra-chat-widget-container .xpert-price-regular {
  font-size: 12px;
  color: #9ca3af;
  text-decoration: line-through;
}

#silfra-chat-widget-container .xpert-sale-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: var(--color-sale);
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

/* --- Product Pager (local prev/next within a message) --- */
#silfra-chat-widget-container .xpert-paginated-products {
  /* wrapper — no extra styling needed */
}

#silfra-chat-widget-container .xpert-product-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
}

#silfra-chat-widget-container .xpert-pager-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--color-primary);
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 78, 100, 0.2);
  pointer-events: auto !important;
}

#silfra-chat-widget-container .xpert-pager-btn:hover:not(:disabled) {
  background: var(--color-primary-dark);
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 78, 100, 0.3);
}

#silfra-chat-widget-container .xpert-pager-btn:disabled {
  background: #d1d5db;
  color: #4b5563;
  cursor: not-allowed;
  box-shadow: none;
}

#silfra-chat-widget-container .xpert-pager-label {
  font-size: var(--fs-xs);
  color: #6b7280;
  font-weight: 600;
  min-width: 70px;
  text-align: center;
}

/* --- Order Button (on product cards) --- */
#silfra-chat-widget-container .xpert-order-btn {
  display: block;
  width: calc(100% - 1.5rem);
  margin: 0 0.75rem 0.75rem;
  padding: 0.5rem 0;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white !important;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 78, 100, 0.2);
  pointer-events: auto !important;
}

#silfra-chat-widget-container .xpert-order-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 78, 100, 0.35);
}

#silfra-chat-widget-container .xpert-order-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 78, 100, 0.2);
}

/* --- Cart Display --- */
#silfra-chat-widget-container .xpert-cart-summary {
  margin-top: 1rem;
  background: white;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 1rem;
}

#silfra-chat-widget-container .xpert-cart-title {
  font-size: var(--fs-md);
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

#silfra-chat-widget-container .xpert-cart-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

#silfra-chat-widget-container .xpert-cart-item {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding: 0.5rem;
  background: #f9fafb;
  border-radius: 6px;
}

#silfra-chat-widget-container .xpert-cart-item-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  background: #e5e7eb;
}

#silfra-chat-widget-container .xpert-cart-item-info {
  flex: 1;
}

#silfra-chat-widget-container .xpert-cart-item-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.25rem;
}

#silfra-chat-widget-container .xpert-cart-item-meta {
  font-size: 11px;
  color: #6b7280;
}

#silfra-chat-widget-container .xpert-cart-item-total {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-cart-totals {
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

#silfra-chat-widget-container .xpert-cart-total-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #4b5563;
}

#silfra-chat-widget-container .xpert-cart-total-final {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  padding-top: 0.5rem;
  border-top: 2px solid #e5e7eb;
  margin-top: 0.25rem;
}

#silfra-chat-widget-container .xpert-cart-empty {
  text-align: center;
  padding: 2rem 1rem;
  color: #9ca3af;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

/* --- Order Confirmation --- */
#silfra-chat-widget-container .xpert-order-confirmation {
  margin-top: 1rem;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 2px solid var(--color-success);
  border-radius: 12px;
  padding: 1.5rem;
}

#silfra-chat-widget-container .xpert-order-header {
  text-align: center;
  margin-bottom: 1rem;
}

#silfra-chat-widget-container .xpert-order-header h4 {
  font-size: 18px;
  font-weight: 700;
  color: #065f46;
  margin-bottom: 0.5rem;
}

#silfra-chat-widget-container .xpert-order-number {
  font-size: 14px;
  color: #047857;
  font-weight: 600;
}

#silfra-chat-widget-container .xpert-order-details {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

#silfra-chat-widget-container .xpert-order-detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 14px;
}

#silfra-chat-widget-container .xpert-order-detail-row:last-child {
  margin-bottom: 0;
}

#silfra-chat-widget-container .xpert-order-status {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

#silfra-chat-widget-container .xpert-order-status.pending {
  background: #fef3c7;
  color: #92400e;
}

#silfra-chat-widget-container .xpert-order-status.processing {
  background: #dbeafe;
  color: #1e40af;
}

#silfra-chat-widget-container .xpert-order-status.completed {
  background: #d1fae5;
  color: #065f46;
}

#silfra-chat-widget-container .xpert-order-total {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-primary);
}

/* --- Payment Section --- */
#silfra-chat-widget-container .xpert-payment-section {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

#silfra-chat-widget-container .xpert-payment-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
}

#silfra-chat-widget-container .xpert-payment-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(0, 78, 100, 0.3);
}

#silfra-chat-widget-container .xpert-payment-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 78, 100, 0.4);
}

#silfra-chat-widget-container .xpert-copy-link-btn {
  padding: 0.75rem 1rem;
  background: transparent;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

#silfra-chat-widget-container .xpert-copy-link-btn:hover {
  background: var(--color-primary);
  color: white;
}

/* --- Suggestions --- */
#silfra-chat-widget-container .xpert-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

#silfra-chat-widget-container .xpert-suggestion-chip {
  padding: 0.5rem 1rem;
  background: white;
  border: 1.5px solid var(--color-primary);
  color: var(--color-primary);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

#silfra-chat-widget-container .xpert-suggestion-chip:hover {
  background: var(--color-primary);
  color: white;
  transform: translateY(-1px);
}

/* --- Flow-prompt action buttons (more prominent) --- */
#silfra-chat-widget-container .xpert-suggestions--flow {
  flex-direction: column;
  gap: 6px;
  margin-top: 16px;
}

#silfra-chat-widget-container .xpert-suggestion-chip--flow {
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(99, 102, 241, 0.25);
}

#silfra-chat-widget-container .xpert-suggestion-chip--flow:hover {
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 78, 100, 0.4);
}

#silfra-chat-widget-container .xpert-suggestion-chip--flow:active {
  transform: translateY(0);
}

/* --- Server Pagination Controls (Load More from backend) --- */
#silfra-chat-widget-container .xpert-pagination-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  margin: 4px 0;
}

#silfra-chat-widget-container .xpert-pagination-info {
  font-size: var(--fs-xs);
  color: #9ca3af;
  margin: 0;
  line-height: 1.4;
}

#silfra-chat-widget-container .xpert-load-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 20px;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 78, 100, 0.2);
  pointer-events: auto !important;
}

#silfra-chat-widget-container .xpert-load-more-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 78, 100, 0.3);
}

#silfra-chat-widget-container .xpert-load-more-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 78, 100, 0.2);
}

/* --- Input Area --- */
#silfra-chat-widget-container .xpert-chat-input-area {
  padding: 1rem;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
  background-color: white;
}

#silfra-chat-widget-container .xpert-chat-input {
  flex: 1;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  padding: 0.75rem;
  font-size: var(--fs-sm);
  resize: none;
  outline: none;
  font-family: inherit;
  margin: 0;
  box-shadow: none;
  background-color: white;
  max-height: 100px;
  transition: border-color 0.2s;
}

#silfra-chat-widget-container .xpert-chat-input:focus {
  border-color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-send-btn {
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0, 78, 100, 0.2);
}

#silfra-chat-widget-container .xpert-send-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 78, 100, 0.3);
}

#silfra-chat-widget-container .xpert-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

#silfra-chat-widget-container .xpert-footer-hint {
  text-align: center;
  font-size: 10px;
  color: #9ca3af;
  padding: 0.5rem;
  background: white;
  margin: 0;
}

/* ── "Powered by MiraQ" attribution bar ──────────────────────────────────
   Last child of the panel on every screen. flex-shrink:0 keeps it at its
   natural height while the screen above it absorbs the remaining space. */
#silfra-chat-widget-container .miraq-powered-by {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 28px;
  padding: 5px 8px;
  background: white;
  border-top: 1px solid #eeede8;
  margin: 0;
  color: #9ca3af;
  font-size: 10px;
  line-height: 1.4;
}

#silfra-chat-widget-container .miraq-attribution {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

#silfra-chat-widget-container .miraq-logo {
  display: block;
  height: 15px;
  width: auto;
  max-width: 80px;
  object-fit: contain;
}

#silfra-chat-widget-container .miraq-powered-by strong {
  color: #6b7280;
  font-weight: 600;
}

/* --- Loader --- */
#silfra-chat-widget-container .dot-loader {
  display: inline-flex;
  gap: 4px;
}

#silfra-chat-widget-container .dot-loader span {
  width: 6px;
  height: 6px;
  background: currentColor;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

#silfra-chat-widget-container .dot-loader span:nth-child(1) {
  animation-delay: -0.32s;
}

#silfra-chat-widget-container .dot-loader span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* --- Order List Cards --- */
#silfra-chat-widget-container .xpert-order-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.25rem;
  width: 100%;
}

#silfra-chat-widget-container .xpert-order-card {
  width: 100%;
  background: #f8fafc;
  border: 1.5px solid var(--color-border);
  border-radius: 10px;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: all 0.18s ease;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

#silfra-chat-widget-container .xpert-order-card:hover {
  background: #eef4f7;
  border-color: var(--color-primary-light);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 78, 100, 0.1);
}

#silfra-chat-widget-container .xpert-order-card:active {
  transform: translateY(0);
  box-shadow: none;
}

/* Row 1: order number + status badge */
#silfra-chat-widget-container .xpert-order-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#silfra-chat-widget-container .xpert-order-card-number {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--color-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

#silfra-chat-widget-container .xpert-order-card-status {
  font-size: var(--fs-xs);
  font-weight: 600;
  border-radius: 20px;
  padding: 0.15rem 0.65rem;
  text-decoration: none !important;
}

/* Row 2: date */
#silfra-chat-widget-container .xpert-order-card-date {
  font-size: var(--fs-xs);
  color: #6b7280;
}

/* Rep attribution, shown only on a report that named reps. Weighted a step
   darker than the date and shipping lines beside it: in a mixed list this is
   the field the admin is scanning down, not incidental metadata. */
#silfra-chat-widget-container .xpert-order-card-rep {
  font-size: var(--fs-xs);
  color: #374151;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Row 3: item count + total */
#silfra-chat-widget-container .xpert-order-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--fs-xs);
  color: #6b7280;
  padding-top: 0.25rem;
  border-top: 1px solid var(--color-border);
  margin-top: 0.1rem;
}

#silfra-chat-widget-container .xpert-order-card-total {
  font-weight: 700;
  color: var(--color-text);
  font-size: var(--fs-sm);
}

/* --- Filter Suggestion Chips --- */
#silfra-chat-widget-container .xpert-filter-suggestions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

#silfra-chat-widget-container .xpert-filter-suggestions-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
}

#silfra-chat-widget-container .xpert-filter-suggestions-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 4px;
  scrollbar-width: none;
}

#silfra-chat-widget-container .xpert-filter-suggestions-row::-webkit-scrollbar {
  display: none;
}

#silfra-chat-widget-container .xpert-filter-chip {
  display: inline-flex !important;
  align-items: center !important;
  gap: 5px !important;
  padding: 4px 10px !important;
  border-radius: 20px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
  transition:
    background 0.15s,
    border-color 0.15s,
    transform 0.1s !important;
  border: 1.5px solid #cbd5e1 !important;
  background: #f8fafc !important;
  color: #475569 !important;
  line-height: 1.4 !important;
}

#silfra-chat-widget-container .xpert-filter-chip:hover {
  background: #f1f5f9 !important;
  border-color: #94a3b8 !important;
  transform: translateY(-1px) !important;
}

#silfra-chat-widget-container .xpert-filter-chip:active {
  transform: translateY(0) !important;
}

#silfra-chat-widget-container .xpert-filter-chip-icon {
  display: flex !important;
  align-items: center !important;
  opacity: 0.7;
  flex-shrink: 0;
}

#silfra-chat-widget-container .xpert-filter-chip-label {
  color: inherit;
}

#silfra-chat-widget-container .xpert-filter-chip--tag {
  border-color: #bfdbfe !important;
  color: #1d4ed8 !important;
  background: #eff6ff !important;
}
#silfra-chat-widget-container .xpert-filter-chip--tag:hover {
  background: #dbeafe !important;
  border-color: #93c5fd !important;
}

#silfra-chat-widget-container .xpert-filter-chip--category {
  border-color: #bbf7d0 !important;
  color: #15803d !important;
  background: #f0fdf4 !important;
}
#silfra-chat-widget-container .xpert-filter-chip--category:hover {
  background: #dcfce7 !important;
  border-color: #86efac !important;
}

#silfra-chat-widget-container .xpert-filter-chip--attribute {
  border-color: #e9d5ff !important;
  color: #7e22ce !important;
  background: #faf5ff !important;
}
#silfra-chat-widget-container .xpert-filter-chip--attribute:hover {
  background: #f3e8ff !important;
  border-color: #d8b4fe !important;
}

#silfra-chat-widget-container .xpert-filter-chip--broaden {
  border-color: #fed7aa !important;
  color: #c2410c !important;
  background: #fff7ed !important;
}
#silfra-chat-widget-container .xpert-filter-chip--broaden:hover {
  background: #ffedd5 !important;
  border-color: #fdba74 !important;
}

/* --- Locked / logged-out state --- */
#silfra-chat-widget-container .xpert-locked-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem 1rem;
  gap: 0.75rem;
}

#silfra-chat-widget-container .xpert-locked-icon {
  font-size: 40px;
  line-height: 1;
  margin-bottom: 0.25rem;
}

#silfra-chat-widget-container .xpert-locked-title {
  font-size: var(--fs-md);
  font-weight: 700;
  color: #374151;
  margin: 0;
}

#silfra-chat-widget-container .xpert-locked-desc {
  font-size: var(--fs-sm);
  color: #6b7280;
  line-height: 1.5;
  max-width: 280px;
  margin: 0;
}

/* ═══════════════════════════════════════════════════════════
   Product Card — clickable state
   ═══════════════════════════════════════════════════════════ */

.xpert-product-card--clickable {
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;
}

.xpert-product-card--clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.xpert-product-card--clickable:active {
  transform: translateY(0);
}

.xpert-product-card--clickable:focus-visible {
  outline: 2px solid var(--color-primary-light);
  outline-offset: 2px;
}

/* ═══════════════════════════════════════════════════════════
   Product Detail Overlay
   ═══════════════════════════════════════════════════════════ */

.xpert-product-detail-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  background: #fff;
  animation: xpert-slide-up 0.25s ease-out;
}

@keyframes xpert-slide-up {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.xpert-product-detail-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* ── Header ── */

.xpert-detail-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.xpert-detail-header-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

/* ── Scrollable content ── */

.xpert-detail-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px !important;
}

/* ── Loading / Error ── */

.xpert-detail-loading,
.xpert-detail-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  text-align: center;
  color: #6b7280;
  flex: 1;
}

.xpert-detail-loading p,
.xpert-detail-error p {
  margin-top: 12px;
  font-size: 14px;
}

.xpert-detail-retry-btn {
  margin-top: 12px;
  padding: 8px 20px;
  background: var(--color-primary-light);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.xpert-detail-retry-btn:hover {
  background: #4f46e5;
}

/* ── Image gallery ── */

.xpert-detail-gallery {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 12px;
  margin-top: 16px;
  background: #f9fafb;
}

.xpert-detail-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.xpert-gallery-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.85);
  color: #111827;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  z-index: 2;
}

.xpert-gallery-btn:hover {
  background: #fff;
}

.xpert-gallery-btn--prev {
  left: 8px;
}

.xpert-gallery-btn--next {
  right: 8px;
}

.xpert-gallery-dots {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}

.xpert-gallery-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: background 0.2s;
}

.xpert-gallery-dot.active {
  background: var(--color-primary-light);
}

/* ── Product info ── */

.xpert-detail-name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 14px 0 8px;
  line-height: 1.3;
}

.xpert-detail-price {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.xpert-detail-price-current,
.xpert-detail-price-sale {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.xpert-detail-price-sale {
  color: #dc2626;
}

.xpert-detail-price-regular {
  font-size: 15px;
  color: #9ca3af;
  text-decoration: line-through;
}

/* ── Meta row: stock + sku ── */

.xpert-detail-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.xpert-detail-stock {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
}

.xpert-detail-stock--in {
  background: #dcfce7;
  color: #15803d;
}

.xpert-detail-stock--out {
  background: #fef2f2;
  color: #dc2626;
}

.xpert-detail-sku {
  font-size: 12px;
  color: #9ca3af;
}

/* ── Rating ── */

.xpert-detail-rating {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
}

.xpert-detail-stars {
  color: #f59e0b;
  font-size: 15px;
  letter-spacing: 1px;
}

.xpert-detail-rating-text {
  font-size: 13px;
  color: #6b7280;
}

/* ── Categories ── */

.xpert-detail-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}

.xpert-detail-category-chip {
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-weight: 500;
}

/* ── Short description ── */

.xpert-detail-short-desc {
  margin-bottom: 14px;
}

.xpert-detail-short-desc p {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
}

/* ── Attributes / Dimensions ── */

.xpert-detail-section-title {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 8px;
}

.xpert-detail-attributes,
.xpert-detail-dimensions {
  margin-bottom: 14px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 10px;
}

.xpert-detail-attr-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 13px;
  border-bottom: 1px solid #f3f4f6;
}

.xpert-detail-attr-row:last-child {
  border-bottom: none;
}

.xpert-detail-attr-name {
  color: #6b7280;
  font-weight: 500;
}

.xpert-detail-attr-value {
  color: #111827;
  text-align: right;
  max-width: 60%;
}

/* ── Full description (collapsible) ── */

.xpert-detail-full-desc {
  margin-bottom: 14px;
}

.xpert-detail-desc-toggle {
  background: none;
  border: none;
  color: var(--color-primary-light);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 0;
}

.xpert-detail-desc-toggle:hover {
  text-decoration: underline;
}

.xpert-detail-desc-body {
  margin-top: 8px;
}

.xpert-detail-desc-body p {
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin: 0;
}

/* ── Action buttons (sticky bottom) ── */

.xpert-detail-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
  background: #fff;
}

.xpert-detail-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  text-decoration: none;
  text-align: center;
  transition: background 0.15s ease;
}

/* ── Close button — pushed to the right end of the header ── */

.xpert-detail-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.xpert-detail-header-title {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.xpert-detail-close-btn {
  margin-left: auto;
  color: #6b7280;
  background: none;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;
}

.xpert-detail-close-btn:hover {
  background: #f3f4f6;
  color: #111827;
}

.xpert-mic-btn.listening {
  animation: micPulse 1.5s infinite;
}

/* --- Category Grid --- */
#silfra-chat-widget-container .xpert-category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 8px;
}

#silfra-chat-widget-container .xpert-category-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  background: #ffffff;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-align: center;
}

#silfra-chat-widget-container .xpert-category-btn:hover {
  background: #f0fdf4; /* Subtle green/blue hover to match chips */
  border-color: var(--color-success);
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

#silfra-chat-widget-container .xpert-category-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
  line-height: 1.3;
  transition: color 0.2s ease;
}

#silfra-chat-widget-container .xpert-category-btn:hover .xpert-category-name {
  color: var(--color-success);
}

#silfra-chat-widget-container .xpert-category-count {
  font-size: 11px;
  color: #6b7280;
  margin-top: 4px;
}

@keyframes micPulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.15);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* ── AI Mode Toggle (HomeScreen profile card) ── */
#silfra-chat-widget-container .xpert-ai-toggle {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

#silfra-chat-widget-container .xpert-toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: background 0.25s ease;
  flex-shrink: 0;
}

#silfra-chat-widget-container .xpert-toggle-switch.xpert-toggle-on {
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
}

#silfra-chat-widget-container .xpert-toggle-switch.xpert-toggle-off {
  background: #c9d3e0;
}

/* Static brand glyph — always sits at the left of the track. The thumb
   slides over it in the off position and uncovers it when on, so it
   reads as "revealed" rather than as a separate control. */
#silfra-chat-widget-container .xpert-toggle-icon {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  z-index: 1;
  pointer-events: none;
}

#silfra-chat-widget-container .xpert-toggle-thumb {
  position: absolute;
  top: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  transition: left 0.25s ease;
  pointer-events: none;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

#silfra-chat-widget-container
  .xpert-toggle-switch.xpert-toggle-on
  .xpert-toggle-thumb {
  left: 23px;
}

#silfra-chat-widget-container
  .xpert-toggle-switch.xpert-toggle-off
  .xpert-toggle-thumb {
  left: 3px;
}

/* ── Variant Picker ──────────────────────────────────────────────────────────
   Rendered inside a bot bubble when flow_state = awaiting_variant_selection.
   Chips let the user pick one value per axis; selections compose into the
   input box but do NOT auto-send.
   ─────────────────────────────────────────────────────────────────────────── */

#silfra-chat-widget-container .xpert-variant-picker {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Axis block — label + chip row */
#silfra-chat-widget-container .xpert-variant-axis {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* Axis label (e.g. "Colors", "Finish") */
#silfra-chat-widget-container .xpert-variant-axis-label {
  font-size: var(--fs-xs);
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
  line-height: 1;
}

/* Chip row — wraps onto multiple lines for long lists */
#silfra-chat-widget-container .xpert-variant-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* Individual chip — default (unselected) state matches suggestion chips */
#silfra-chat-widget-container .xpert-variant-chip {
  padding: 5px 12px;
  background: white;
  border: 1.5px solid var(--color-primary);
  color: var(--color-primary);
  border-radius: 20px;
  font-size: var(--fs-xs);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  line-height: 1.4;
  white-space: nowrap;
}

#silfra-chat-widget-container .xpert-variant-chip:hover:not(:disabled) {
  background: var(--color-primary-light);
  border-color: var(--color-primary-light);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 78, 100, 0.2);
}

#silfra-chat-widget-container .xpert-variant-chip:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: none;
}

/* Disabled — the combination doesn't exist for what's selected on the other
   axes (e.g. Finish=Honed once Colors=Beleza is picked). Grayed out and
   inert rather than hidden, so the rep can see it was considered and why
   (title tooltip), not wonder where an option went. */
#silfra-chat-widget-container .xpert-variant-chip:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: white;
  color: #9ca3af;
  border-color: #d1d5db;
  transform: none;
  box-shadow: none;
}

/* Selected state — filled with primary gradient, matches the send button */
#silfra-chat-widget-container .xpert-variant-chip--selected {
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  border-color: transparent;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 78, 100, 0.25);
}

#silfra-chat-widget-container .xpert-variant-chip--selected:hover {
  background: linear-gradient(
    135deg,
    var(--color-primary) 0%,
    var(--color-primary-dark) 100%
  );
  border-color: transparent;
  color: white;
  box-shadow: 0 3px 10px rgba(0, 78, 100, 0.35);
}

/* ── Place Order button (below VariantPicker) ── */
#silfra-chat-widget-container .xpert-place-order-btn {
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 9px 16px;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white;
  border: none;
  border-radius: 20px;
  font-size: var(--fs-sm);
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 78, 100, 0.2);
}

#silfra-chat-widget-container .xpert-place-order-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 78, 100, 0.35);
}

#silfra-chat-widget-container .xpert-place-order-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 78, 100, 0.2);
}

#silfra-chat-widget-container .xpert-place-order-btn:disabled {
  background: #d1d5db;
  color: #4b5563;
  cursor: not-allowed;
  box-shadow: none;
}

/* --- Shopify full-height panel override ---
     When the widget is mounted inside #silfra-panel-root (ShopifyWidgetContainer),
     the panel fills the full fixed container instead of floating as a bubble. */
#silfra-panel-root #silfra-chat-widget-container .xpert-panel {
  position: static !important;
  width: 100% !important;
  height: 100vh !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  bottom: auto !important;
  right: auto !important;
}

/* --- Desktop Side Panel --- */
@media (min-width: 769px) {
  #silfra-chat-widget-container .xpert-panel--side {
    top: 0;
    right: 0;
    bottom: 0;
    width: 25vw;
    min-width: 320px;
    height: 100vh;
    border-radius: 0;
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
    transition: width 0.3s ease;
  }
  #silfra-chat-widget-container .xpert-panel--side.xpert-panel--expanded {
    width: 50vw;
  }
}

/* --- Side Tab (desktop closed state) --- */
#silfra-chat-widget-container .xpert-side-tab {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 48px;
  padding: 14px 0;
  background: linear-gradient(
    180deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  color: white;
  border-radius: 10px 0 0 10px;
  box-shadow: -3px 0 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 2147483646;
  transition:
    width 0.2s ease,
    box-shadow 0.2s ease;
  pointer-events: auto !important;
}

#silfra-chat-widget-container .xpert-side-tab:hover {
  width: 56px;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.3);
}

#silfra-chat-widget-container .xpert-side-tab-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: white;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
}

#silfra-chat-widget-container .xpert-card-actions {
  display: flex;
  align-items: stretch;
  gap: 4px;
  margin-top: 6px;
}

/* Manual quantity prompt shown in place of the actions row after
   "Add to Cart" is clicked — no preset quantities, just a number input. */
#silfra-chat-widget-container .xpert-cart-qty-row {
  display: flex;
  align-items: stretch;
  gap: 4px;
  margin-top: 6px;
}

#silfra-chat-widget-container .xpert-cart-qty-input {
  flex: 1 1 auto;
  min-width: 0;
  padding: 6px 8px;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  font-size: 13px;
  outline: none;
}

#silfra-chat-widget-container .xpert-cart-qty-input:focus {
  border-color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-cart-qty-confirm {
  flex: 0 0 auto;
  padding: 0 10px;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  border: 1px solid transparent;
  color: #ffffff;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

#silfra-chat-widget-container .xpert-cart-qty-confirm:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

#silfra-chat-widget-container .xpert-cart-qty-cancel {
  flex: 0 0 28px;
  background: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 6px;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
}

#silfra-chat-widget-container .xpert-card-actions .xpert-add-to-cart-btn {
  flex: 0 0 36px;
}

#silfra-chat-widget-container .xpert-card-actions .xpert-similar-btn {
  flex: 1 1 84px;
  min-width: 0;
}

/* Add to cart is the conversion action, so it reads as primary. Previously it
   was a 32px icon-only square sitting next to a bordered text button, which
   inverted the hierarchy — the eye went to "show similar" first. The square
   was also below the 44px touch minimum, inside a card that is itself
   clickable, so a missed tap opened the product detail instead of adding. */
#silfra-chat-widget-container .xpert-add-to-cart-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  /* Square. aspect-ratio rather than a hard height so the button still grows
     if the row's stretch alignment gives it more, without ever going oblong.
     The old width:100% made it a wide bar; before that, height:100% made it a
     tall one that stretched to match the wrapped text button beside it. */
  width: 36px;
  height: 36px;
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
  padding: 0;
  background: linear-gradient(
    135deg,
    var(--color-primary-light) 0%,
    var(--color-primary) 100%
  );
  border: 1px solid transparent;
  color: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 1px 4px rgba(0, 78, 100, 0.18);
}

#silfra-chat-widget-container .xpert-add-to-cart-btn:hover {
  background: var(--color-primary-dark);
  color: #ffffff;
}

/* Secondary discovery action: ghost styling, one short label. "Show Similar
   Products" is 21 characters and cannot fit the ~86px available in a 2-up
   grid on a 375px phone at any font size that stays legible. */
#silfra-chat-widget-container .xpert-similar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 30px;
  padding: 5px 8px;
  background: transparent;
  border: 1px solid var(--color-primary-light);
  color: var(--color-primary);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: center;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#silfra-chat-widget-container .xpert-similar-btn:hover:not(:disabled) {
  background: var(--color-primary-light);
  color: #ffffff;
}

#silfra-chat-widget-container .xpert-similar-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Icon swap target — hidden here, shown at ≤360px below. Both label and
   icon always render in the JSX; only display toggles, so there's no
   layout shift and no JS width detection needed. */
#silfra-chat-widget-container .xpert-similar-btn-icon {
  display: none;
}

#silfra-chat-widget-container .xpert-similar-prompt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  padding: 10px 12px;
  background: var(--color-background-secondary, #f8fafc);
  border: 1px solid var(--color-border-tertiary, #e2e8f0);
  border-radius: 10px;
}

#silfra-chat-widget-container .xpert-similar-prompt__text {
  font-size: 12px;
  color: var(--color-text-secondary, #475569);
  line-height: 1.4;
}

#silfra-chat-widget-container .xpert-similar-prompt__text strong {
  color: var(--color-text-primary, #1f2937);
  font-weight: 600;
}

#silfra-chat-widget-container .xpert-similar-prompt__btn {
  flex-shrink: 0;
  padding: 6px 14px;
  background: #ffffff;
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;
}

#silfra-chat-widget-container .xpert-similar-prompt__btn:hover:not(:disabled) {
  opacity: 0.88;
}

#silfra-chat-widget-container .xpert-similar-prompt__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

#silfra-chat-widget-container .xpert-message-row.bot .xpert-message-bubble {
  flex: 1;
}

/* Row 3: shipping address */
#silfra-chat-widget-container .xpert-order-card-shipping {
  font-size: var(--fs-xs);
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.miraq-limit-banner {
  margin: 10px 14px;
  padding: 14px 16px;
  background: #fff8f0;
  border: 1.5px solid #f5d9b0;
  border-radius: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.miraq-limit-icon {
  font-size: 22px;
}
.miraq-limit-title {
  font-weight: 700;
  font-size: 13px;
  color: #1c1c1a;
  margin: 0;
}
.miraq-limit-subtitle {
  font-size: 12px;
  color: #888;
  margin: 0;
}
.miraq-limit-upgrade-btn {
  margin-top: 6px;
  padding: 9px 20px;
  background: #1c1c1a;
  color: #fff;
  border: none;
  border-radius: 9px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.03em;
}
.miraq-limit-upgrade-btn:hover {
  background: #333;
}

.miraq-cart-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 12px;
  padding: 7px 14px;
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s;
}

.miraq-cart-back-btn:hover {
  background: #f3f4f6;
  color: #1c1c1a;
}

/* ── Shared button system ─────────────────────────────────────── */
.bo-btn {
  padding: 7px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition:
    opacity 0.15s,
    transform 0.1s;
  white-space: nowrap;
}
.bo-btn:active {
  transform: scale(0.97);
}
.bo-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.bo-btn--primary {
  background: #2563eb;
  color: #fff;
}
.bo-btn--primary:hover:not(:disabled) {
  background: #1d4ed8;
}

.bo-btn--secondary {
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #cbd5e1;
}
.bo-btn--secondary:hover:not(:disabled) {
  background: #e2e8f0;
}

.bo-btn--ghost {
  background: transparent;
  color: #64748b;
  border: 1px solid #e2e8f0;
}
.bo-btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
}

.bo-btn--danger {
  background: transparent;
  color: #ef4444;
  border: 1px solid #fca5a5;
}
.bo-btn--danger:hover:not(:disabled) {
  background: #fef2f2;
}

.bo-confirm__cancel-row {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f1f5f9;
}

/* ── Bulk Order trigger button (above textarea) ───────────────── */
.xpert-bulk-trigger-row {
  padding: 6px 12px 0;
  display: flex;
  gap: 6px;
}
.xpert-bulk-trigger-btn {
  padding: 5px 14px;
  border-radius: 20px;
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.xpert-bulk-trigger-btn:hover {
  background: #dbeafe;
}

/* ── Confirmation card ────────────────────────────────────────── */
.bo-confirm {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  margin-top: 8px;
  font-size: 13px;
}
.bo-confirm__title {
  font-weight: 600;
  margin: 0 0 10px;
  color: #1e293b;
}
.bo-confirm__table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
}
.bo-confirm__thead,
.bo-confirm__row {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 2fr;
  gap: 8px;
  padding: 7px 10px;
  align-items: center;
}
.bo-confirm__thead {
  background: #f1f5f9;
  font-weight: 600;
  font-size: 11.5px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.bo-confirm__row {
  border-top: 1px solid #f1f5f9;
}
.bo-confirm__row--skip {
  opacity: 0.5;
}
.bo-confirm__row:hover {
  background: #f8fafc;
}
.bo-confirm__status {
  font-size: 12px;
}

/* Grouped-by-order layout: one card per order (recipient + address shown
   once), several product rows underneath. Replaces the flat Customer/
   Product/Qty/Status table for resolved, non-skipped lines — those keep
   the old .bo-confirm__table/__thead/__row rules above, now used only for
   unresolved/skipped lines via .bo-confirm__issue-row below. */
.bo-confirm__groups {
  margin-bottom: 10px;
}
.bo-confirm__group {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
}
.bo-confirm__group:last-child {
  margin-bottom: 0;
}
.bo-confirm__group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}
.bo-confirm__group-name {
  font-size: 13.5px;
  font-weight: 600;
  color: #1e293b;
}
.bo-confirm__group-address {
  color: #475569;
  font-size: 12px;
  margin: 4px 0 8px;
}
.bo-confirm__group-address--warn {
  color: #92400e;
}
.bo-confirm__group-items {
  border-top: 1px solid #f1f5f9;
  padding-top: 6px;
}
.bo-confirm__group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #1e293b;
  padding: 2px 0;
}
.bo-confirm__group-item-qty {
  color: #64748b;
}
.bo-confirm__issue-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
  opacity: 0.6;
}
.bo-confirm__issue-row:last-child {
  margin-bottom: 0;
}
.bo-confirm__issue-who {
  font-weight: 500;
  color: #1e293b;
}
.bo-confirm__issue-what {
  color: #475569;
}
.bo-confirm__warning {
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 12px;
  margin: 6px 0;
}
.bo-confirm__ready {
  color: #166534;
  font-size: 12.5px;
  margin: 6px 0 10px;
}
.bo-confirm__btns {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* ── Variant prompt card ──────────────────────────────────────── */
.bo-variant {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  margin-top: 8px;
}
.bo-variant__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 12px;
}
.bo-variant__progress {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  background: #e2e8f0;
  border-radius: 20px;
  padding: 2px 8px;
}
.bo-variant__product {
  font-size: 14px;
  color: #1e293b;
}
.bo-variant__company {
  font-size: 12px;
  color: #64748b;
}

.bo-variant__axis {
  margin-bottom: 12px;
}
.bo-variant__axis-label {
  font-size: 11.5px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 6px;
}
.bo-variant__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.bo-chip {
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
  font-size: 12.5px;
  cursor: pointer;
  transition: all 0.15s;
}
.bo-chip:hover {
  border-color: #2563eb;
  color: #2563eb;
  background: #eff6ff;
}
.bo-chip--on {
  background: #2563eb;
  color: #fff;
  border-color: #2563eb;
}

.bo-variant__qty-input {
  margin-top: 8px;
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 13px;
  width: 120px;
  outline: none;
}
.bo-variant__qty-input:focus {
  border-color: #2563eb;
}
.bo-variant__confirm {
  width: 100%;
  margin-top: 4px;
  justify-content: center;
}

/* -- Order CSV export controls (admin) ------------------------- */
.xpert-order-list-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
.xpert-order-download-all,
.xpert-order-download {
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
  white-space: nowrap;
}
.xpert-order-download-all:hover,
.xpert-order-download:hover {
  background: #dbeafe;
}
.xpert-order-download {
  margin-top: 8px;
  width: 100%;
  text-align: center;
}
.xpert-order-card[role="button"] {
  cursor: pointer;
}
.xpert-order-card[role="button"]:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

/* ── Date range picker card (order reporting) ─────────────────── */
.bo-daterange {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  margin-top: 8px;
}
.bo-daterange__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 12px;
}
.bo-daterange__label {
  font-size: 11.5px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.bo-daterange__rep {
  font-size: 12px;
  color: #64748b;
}
.bo-daterange__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.bo-daterange__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.bo-daterange__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 130px;
  min-width: 0;
}
.bo-daterange__field-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
}
.bo-daterange__input {
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  color: #1e293b;
  background: #fff;
  outline: none;
  width: 100%;
  box-sizing: border-box;
}
.bo-daterange__input:focus {
  border-color: #2563eb;
}
.bo-daterange__input:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  cursor: not-allowed;
}
.bo-daterange__error {
  font-size: 12px;
  color: #dc2626;
  margin: 8px 0 0;
}
.bo-daterange__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}
.bo-daterange__apply {
  justify-content: center;
}
.bo-daterange__apply:disabled,
.bo-daterange .bo-chip:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Address confirmation card ────────────────────────────────── */
.bo-address {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px;
  margin-top: 8px;
  font-size: 13px;
}
.bo-address__header {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
}
.bo-address__progress {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  background: #e2e8f0;
  border-radius: 20px;
  padding: 2px 8px;
}
.bo-address__name {
  font-size: 14px;
  color: #1e293b;
}
.bo-address__items {
  color: #475569;
  margin: 0 0 10px;
}
.bo-address__block {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
}
.bo-address__label {
  font-size: 11.5px;
  font-weight: 600;
  color: #64748b;
  margin: 0 0 4px;
}
.bo-address__value {
  color: #1e293b;
  margin: 0;
  line-height: 1.5;
}

/* ── Address confirmation card — editing panel (all new) ──────── */

.bo-address__panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 4px;
}

.bo-address__panel-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Section heading row: label left, "Same as billing" button right */
.bo-address__panel-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: -2px; /* tighten gap to first field */
}

/* Remove bottom margin from label when it sits inside section-head */
.bo-address__panel-section-head .bo-address__label {
  margin: 0;
}

/* Each label + input pair stacked vertically */
.bo-address__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.bo-address__field-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1;
}

/* Shared input / select style */
.bo-address__input {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  font-family: inherit;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.bo-address__input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

/* Chevron for selects */
select.bo-address__input {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 28px;
  cursor: pointer;
}

/* "Same as billing" — compact ghost pill */
.bo-address__copy.bo-btn {
  padding: 3px 10px;
  font-size: 11.5px;
  border-radius: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ── Two small fixes to existing rules ───────────────────────── */

/* Give the Save/Cancel buttons row a top margin so it breathes */
.bo-address .bo-confirm__btns {
  margin-top: 6px;
}

/* Align items label with a little bottom spacing */
.bo-address__items {
  margin: 0 0 12px; /* was 0 0 10px — just a touch more room */
}

/* ── Product Recent Orders Card ─────────────────────────────────────────── */

#silfra-chat-widget-container .xpert-product-recent-orders {
  margin-top: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
}

#silfra-chat-widget-container .xpert-product-recent-orders__heading {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 8px;
}

#silfra-chat-widget-container .xpert-product-recent-orders__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

#silfra-chat-widget-container .xpert-product-recent-orders__item {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s ease;
}

#silfra-chat-widget-container .xpert-product-recent-orders__item:hover {
  border-color: var(--color-primary-light);
  background: #f0f9ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 78, 100, 0.1);
}

#silfra-chat-widget-container .xpert-product-recent-orders__item-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#silfra-chat-widget-container .xpert-product-recent-orders__order-number {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-primary);
}

#silfra-chat-widget-container .xpert-product-recent-orders__date {
  font-size: 11px;
  color: #94a3b8;
}

#silfra-chat-widget-container .xpert-product-recent-orders__item-detail {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

#silfra-chat-widget-container .xpert-product-recent-orders__customer {
  font-size: 12.5px;
  font-weight: 500;
  color: #1e293b;
}

#silfra-chat-widget-container .xpert-product-recent-orders__items-text {
  font-size: 11.5px;
  color: #64748b;
}

#silfra-chat-widget-container .xpert-product-recent-orders__reorder-cta {
  margin-top: 4px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--color-primary-light);
  text-align: right;
}

#silfra-chat-widget-container .xpert-product-recent-orders__email {
  font-size: 11px;
  color: #94a3b8;
}

#silfra-chat-widget-container .xpert-order-card-item {
  margin-bottom: 8px;
}

#silfra-chat-widget-container .xpert-order-card-item:last-child {
  margin-bottom: 0;
}

#silfra-chat-widget-container .xpert-order-card-item-variation {
  font-size: 11px;
  color: #999;
  margin: 2px 0 0 0;
  text-transform: capitalize;
  letter-spacing: 0.02em;
}

#silfra-chat-widget-container .xpert-order-detail-item {
  margin-bottom: 8px;
}

#silfra-chat-widget-container .xpert-order-detail-item:last-child {
  margin-bottom: 0;
}

#silfra-chat-widget-container .xpert-order-detail-variation {
  font-size: 11px;
  color: #999;
  margin: 2px 0 0 0;
  text-transform: capitalize;
  letter-spacing: 0.02em;
}

/* ═══════════════════════════════════════════════════════════════════════════
   MOBILE PASS — viewports ≤768px
   ═══════════════════════════════════════════════════════════════════════════
   Placed at the end of the file deliberately: several rules here need to beat
   selectors with higher specificity declared earlier (notably
   .xpert-panel.wide, which is two classes to .xpert-panel's one). Source order
   settles those ties without resorting to !important.

   The panel stays an inset floating card on mobile — it is NOT promoted to a
   full-screen sheet. Everything below fixes what breaks inside that card at
   narrow widths.
   ═════════════════════════════════════════════════════════════════════════ */

@media (max-width: 768px) {
  /* ── Panel shell ─────────────────────────────────────────────────────────
     100dvh instead of 100vh: on mobile Safari and Chrome, 100vh is the height
     with browser chrome COLLAPSED, so a 100vh-derived panel extends under the
     URL bar and the composer sits off-screen until the user scrolls. dvh
     tracks the visible viewport. The vh line is kept first as the fallback for
     browsers without dvh (pre-2022); they get the old behaviour rather than a
     broken rule. */
  /* Full screen on mobile: no inset, no radius, no shadow. Both selectors are
     named because .xpert-panel.wide is two classes to .xpert-panel's one and
     would otherwise win on specificity and force a 500px panel onto a phone. */
  #silfra-chat-widget-container .xpert-panel,
  #silfra-chat-widget-container .xpert-panel.wide {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    max-height: none;
    border-radius: 0;
    box-shadow: none;
  }

  /* Now that the panel touches the top of the screen, the header sits under
     the status bar / notch unless it carries the inset itself. */
  #silfra-chat-widget-container .xpert-chat-header,
  #silfra-chat-widget-container .xpert-home-header,
  .miraq-cart-header,
  .miraq-checkout-header {
    padding-top: calc(0.875rem + env(safe-area-inset-top, 0px)) !important;
  }

  /* Shopify mounts the panel inside a fixed container and forces 100vh with
     !important, which has the same URL-bar problem. Matched here with
     !important only because the rule it overrides uses it. */
  #silfra-panel-root #silfra-chat-widget-container .xpert-panel {
    height: 100dvh !important;
  }

  /* ── Floating button ───────────────────────────────────────────────────── */
  #silfra-chat-widget-container .xpert-floating-btn {
    bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    right: 16px;
    /* 56px keeps it above the 44px minimum touch target with room to spare. */
    width: 56px;
    height: 56px;
  }

  /* ── iOS auto-zoom prevention ───────────────────────────────────────────
     Safari zooms the page when a focused input's computed font-size is under
     16px, and does not zoom back out afterwards — the shopper is left on a
     magnified, horizontally-scrolled page. Every text-entry control inside the
     widget is pinned to 16px on mobile. Visual weight is preserved by the
     tighter padding below rather than by shrinking the type. */
  #silfra-chat-widget-container input,
  #silfra-chat-widget-container textarea,
  #silfra-chat-widget-container select,
  .bo-address__input,
  .bo-variant__qty-input {
    font-size: 16px;
  }

  /* ── Composer ──────────────────────────────────────────────────────────── */
  #silfra-chat-widget-container .xpert-chat-input-area {
    padding: 0.625rem 0.75rem;
    gap: 0.5rem;
  }

  #silfra-chat-widget-container .xpert-chat-input {
    padding: 0.5rem 0.625rem;
    max-height: 84px;
  }

  #silfra-chat-widget-container .xpert-send-btn,
  #silfra-chat-widget-container .xpert-mic-btn {
    min-width: 44px;
    min-height: 44px;
    padding: 0.5rem 0.75rem;
    flex-shrink: 0;
  }

  /* ── Long-string overflow ───────────────────────────────────────────────
     SKUs, URLs and order numbers have no break opportunities and will push the
     bubble wider than the panel, which scrolls the whole message list
     sideways. anywhere lets the browser break mid-token as a last resort. */
  #silfra-chat-widget-container .xpert-message-bubble,
  #silfra-chat-widget-container .xpert-bubble-content,
  #silfra-chat-widget-container .xpert-message-content {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  #silfra-chat-widget-container .xpert-chat-messages {
    padding: 0.5rem;
    overflow-x: hidden;
  }

  /* ── Product grid ───────────────────────────────────────────────────────
     Two columns is still right at 360px (≈150px per card), but the tracks need
     an explicit 0 minimum: 1fr's default min-content floor lets a long product
     name widen the track and overflow the panel. */
  /* Always two per row. minmax(0,...) rather than a bare 1fr: 1fr's implicit
     min-content floor lets a long product name widen its track and push the
     grid past the panel. Dropping to one column costs twice the scrolling for
     no readability gain once the panel is full width. */
  #silfra-chat-widget-container .xpert-product-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  #silfra-chat-widget-container .xpert-product-info {
    padding: 0.625rem;
  }

  #silfra-chat-widget-container .xpert-product-name {
    overflow-wrap: anywhere;
  }

  /* ── Chips, suggestions and pagers: wrap instead of overflowing ────────── */
  #silfra-chat-widget-container .xpert-suggestions,
  #silfra-chat-widget-container .xpert-suggestions--flow,
  #silfra-chat-widget-container .xpert-filter-suggestions-row,
  #silfra-chat-widget-container .xpert-variant-chips,
  #silfra-chat-widget-container .xpert-detail-categories,
  #silfra-chat-widget-container .xpert-pagination-controls,
  #silfra-chat-widget-container .xpert-bottom-actions {
    flex-wrap: wrap;
  }

  #silfra-chat-widget-container .xpert-suggestion-chip,
  #silfra-chat-widget-container .xpert-filter-chip,
  #silfra-chat-widget-container .xpert-variant-chip,
  #silfra-chat-widget-container .xpert-category-btn {
    min-height: 36px;
  }

  #silfra-chat-widget-container .xpert-pager-label {
    min-width: 0;
  }

  /* ── Icon buttons: meet the 44px touch minimum ─────────────────────────── */
  #silfra-chat-widget-container .xpert-icon-btn,
  #silfra-chat-widget-container .xpert-detail-close-btn,
  #silfra-chat-widget-container .xpert-gallery-btn {
    min-width: 44px;
    min-height: 44px;
  }

  /* ── Product card actions ───────────────────────────────────────────────
     Add to cart gets the full 44px: it sits inside a card that is itself
     clickable, so a missed tap doesn't do nothing, it opens the product
     detail. The secondary button stays at 36px — deliberately under the
     guideline, because giving both actions equal weight in a 2-up grid costs
     roughly 90px of card height and pushes the next row of products off
     screen. A mis-tap there is recoverable. */
  #silfra-chat-widget-container .xpert-add-to-cart-btn {
    min-height: 36px;
  }

  #silfra-chat-widget-container .xpert-similar-btn {
    min-height: 36px;
  }

  /* ── Order cards ────────────────────────────────────────────────────────
     Order number + status side by side runs out of room once the status is
     more than a word ("Processing", "Partially refunded"). */
  #silfra-chat-widget-container .xpert-order-card-header,
  #silfra-chat-widget-container .xpert-order-card-footer,
  #silfra-chat-widget-container .xpert-order-header,
  #silfra-chat-widget-container .xpert-order-detail-row {
    flex-wrap: wrap;
    gap: 4px;
  }

  #silfra-chat-widget-container .xpert-order-card-item,
  #silfra-chat-widget-container .xpert-order-detail-item {
    overflow-wrap: anywhere;
  }

  /* ── Product detail panel ───────────────────────────────────────────────
     4:3 eats most of a phone-height panel; 3:2 leaves room for the title and
     price without scrolling. */
  #silfra-chat-widget-container .xpert-detail-gallery {
    aspect-ratio: 3 / 2;
    margin-top: 12px;
  }

  #silfra-chat-widget-container .xpert-detail-content {
    padding-left: 12px;
    padding-right: 12px;
  }

  #silfra-chat-widget-container .xpert-detail-attr-row,
  #silfra-chat-widget-container .xpert-detail-meta-row {
    flex-wrap: wrap;
    gap: 2px 8px;
  }

  #silfra-chat-widget-container .xpert-detail-actions {
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));
  }

  /* ── Locked / empty states ──────────────────────────────────────────────
     A fixed 280px max-width leaves a lopsided ragged block once the panel is
     narrower than that plus its padding. */
  #silfra-chat-widget-container .xpert-locked-desc {
    max-width: 100%;
  }

  /* ═══ Bulk order (CS rep) surfaces ═══════════════════════════════════════
     These are the widest layouts in the widget and the ones that break first.
     Note they are NOT scoped to #silfra-chat-widget-container in the base
     stylesheet, so they aren't scoped here either. */

  /* The 2fr 2fr 1fr 2fr confirmation table cannot hold four columns at 336px.
     Restructured into one stacked record per row, with the header hidden since
     it no longer labels anything, and each cell labelled inline instead. */
  .bo-confirm__thead {
    display: none;
  }

  .bo-confirm__row {
    grid-template-columns: minmax(0, 1fr);
    gap: 2px;
    padding: 10px;
  }

  .bo-confirm__row > * {
    overflow-wrap: anywhere;
  }

  .bo-confirm__table {
    margin-bottom: 8px;
  }

  /* Same reasoning as .bo-confirm__row above, for the grouped-order card:
     "who · what x qty · status" wrapping mid-phrase at 336px reads as
     broken, so it stacks into one field per line instead. */
  .bo-confirm__issue-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  /* Stacked action buttons: three side-by-side buttons at 336px leave each too
     narrow to label, and wrapping mid-row reads as a broken layout. */
  .bo-confirm__btns {
    flex-direction: column;
    align-items: stretch;
  }

  .bo-confirm__btns .bo-btn {
    width: 100%;
    min-height: 44px;
    white-space: normal;
  }

  /* The address panel's "Same as billing" pill sits beside a section heading
     and must stay on one line, so it opts out of the stacking above. */
  .bo-address__panel-section-head {
    flex-wrap: wrap;
    gap: 6px;
  }

  .bo-address__copy.bo-btn {
    width: auto;
    min-height: 32px;
  }

  .bo-address__input {
    padding: 9px 10px;
  }

  select.bo-address__input {
    padding-right: 30px;
  }

  .bo-address__panel {
    max-height: none;
  }

  .bo-variant__qty-input {
    width: 100%;
    max-width: 160px;
  }

  .bo-variant__header,
  .bo-address__header {
    flex-wrap: wrap;
    gap: 4px;
  }

  .bo-chip {
    min-height: 36px;
  }
}

/* ── Very narrow phones (≤360px) ─────────────────────────────────────────
   iPhone SE and small Androids. Product cards below ~150px stop showing a
   usable image plus name plus price, so the grid drops to a single column. */
/* ── Very narrow phones (≤360px) ─────────────────────────────────────────
   The grid deliberately stays at two columns here. The panel override that
   used to live in this block is gone too — the panel is full screen on every
   mobile width now, so there is no inset left to shrink. */
@media (max-width: 360px) {
  #silfra-chat-widget-container .xpert-chat-header {
    padding: 0.5rem 0.625rem;
  }

  /* Buy back a few more pixels for the action row at this width. */
  #silfra-chat-widget-container .xpert-product-info {
    padding: 0.5rem;
  }

  /* Text no longer fits without wrapping or truncating at this width, even
     after the padding trim above — swap to an icon-only square matching
     .xpert-add-to-cart-btn's 36px footprint instead of fighting for space. */
  #silfra-chat-widget-container .xpert-card-actions .xpert-similar-btn {
    flex: 0 0 36px;
    min-width: 36px;
    padding: 0;
  }

  #silfra-chat-widget-container .xpert-similar-btn-label {
    display: none;
  }

  #silfra-chat-widget-container .xpert-similar-btn-icon {
    display: inline-flex;
  }
}

/* ── Landscape phones ────────────────────────────────────────────────────
   Short viewports: the profile card and feature list consume the whole panel
   and the composer is pushed out of reach. */
@media (max-width: 900px) and (max-height: 480px) and (orientation: landscape) {
  /* Panel sizing is handled by the full-screen rule above; only the content
     needs compacting here, because a 480px-tall viewport leaves almost nothing
     for the message list once the profile card and feature list are drawn. */
  #silfra-chat-widget-container .xpert-profile-card {
    margin: 0.5rem;
  }

  #silfra-chat-widget-container .xpert-profile-card .xpert-profile-card-info {
    padding: 0.75rem;
  }

  #silfra-chat-widget-container .xpert-features-list {
    display: none;
  }
}

/* ── Reduced motion ──────────────────────────────────────────────────────
   The slide-in transforms are the widget's most motion-heavy moment and the
   panel is often opened mid-scroll. */
@media (prefers-reduced-motion: reduce) {
  #silfra-chat-widget-container *,
  #silfra-chat-widget-container *::before,
  #silfra-chat-widget-container *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* --- Top sellers by collection (SHOW_TOP_SELLERS_BY_COLLECTION) --- */
#silfra-chat-widget-container .xpert-top-sellers-by-collection {
  margin-top: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

#silfra-chat-widget-container .xpert-top-sellers-heading {
  font-size: var(--fs-xs);
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 0.15rem;
}

#silfra-chat-widget-container .xpert-top-sellers-group {
  border: 1.5px solid var(--color-border);
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
}

#silfra-chat-widget-container .xpert-top-sellers-group-toggle {
  width: 100%;
  background: transparent;
  border: none;
  padding: 0.6rem 0.85rem;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: var(--fs-sm);
  color: var(--color-text);
  transition: background 0.18s ease;
}

#silfra-chat-widget-container .xpert-top-sellers-group-toggle:hover {
  background: #eef4f7;
}

#silfra-chat-widget-container .xpert-top-sellers-group-toggle:focus-visible {
  outline: 2px solid var(--color-primary-light);
  outline-offset: -2px;
}

#silfra-chat-widget-container .xpert-top-sellers-group-name {
  font-weight: 700;
  color: var(--color-primary);
  flex: 1;
  /* Long collection names must not push the count off the row. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#silfra-chat-widget-container .xpert-top-sellers-group-count {
  font-size: var(--fs-xs);
  font-weight: 600;
  color: #6b7280;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 20px;
  padding: 0.15rem 0.6rem;
  white-space: nowrap;
}

/* The product grid sits inside the expanded group, so it needs its own
   padding — .xpert-product-grid only carries a top margin. */
#silfra-chat-widget-container .xpert-top-sellers-group .xpert-product-grid {
  padding: 0 0.6rem 0.7rem;
  margin-top: 0.25rem;
}

/* ── Chat history search ─────────────────────────────────────────────────────
   Overlay over .xpert-chat-body (position: relative) opened from the header
   search icon. Buttons and inputs are reset explicitly: store themes style
   bare <button>/<input> heavily and that bleeds into the widget. */
#silfra-chat-widget-container .xpert-hs-panel {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  background: var(--color-surface);
  animation: xpert-hs-in 0.15s ease-out;
}

@keyframes xpert-hs-in {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: none; }
}

#silfra-chat-widget-container .xpert-hs-bar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid var(--color-border);
}

#silfra-chat-widget-container .xpert-hs-icon-btn,
#silfra-chat-widget-container .xpert-hs-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 6px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #4b5563;
  cursor: pointer;
  box-shadow: none;
  min-width: 0;
  min-height: 0;
}

#silfra-chat-widget-container .xpert-hs-icon-btn:hover,
#silfra-chat-widget-container .xpert-hs-clear:hover {
  background: #f3f4f6;
  color: var(--color-text);
}

#silfra-chat-widget-container .xpert-hs-input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.25rem 0 0.65rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: #f9fafb;
  transition: border-color 0.15s, box-shadow 0.15s;
}

#silfra-chat-widget-container .xpert-hs-input-wrap:focus-within {
  border-color: var(--color-primary-light);
  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.12);
  background: var(--color-surface);
}

#silfra-chat-widget-container .xpert-hs-input-icon {
  color: #9ca3af;
  flex-shrink: 0;
}

#silfra-chat-widget-container .xpert-hs-input {
  flex: 1;
  min-width: 0;
  height: 36px;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  box-shadow: none;
  font: inherit;
  font-size: var(--fs-sm);
  color: var(--color-text);
  -webkit-appearance: none;
  appearance: none;
}

/* Native clear "x" duplicates ours. */
#silfra-chat-widget-container .xpert-hs-input::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

#silfra-chat-widget-container .xpert-hs-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.25rem 0 0.75rem;
}

#silfra-chat-widget-container .xpert-hs-hint {
  margin: 1.5rem 1.25rem;
  font-size: var(--fs-sm);
  color: #6b7280;
  text-align: center;
  line-height: 1.5;
}

#silfra-chat-widget-container .xpert-hs-error {
  margin: 0.5rem 0.75rem;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: var(--fs-xs);
}

#silfra-chat-widget-container .xpert-hs-link {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: var(--color-primary);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

#silfra-chat-widget-container .xpert-hs-list {
  list-style: none;
  margin: 0;
  padding: 0;
  transition: opacity 0.15s;
}

/* A newer query is in flight: keep the old hits visible but dimmed. */
#silfra-chat-widget-container .xpert-hs-list--stale {
  opacity: 0.55;
}

#silfra-chat-widget-container .xpert-hs-item {
  margin: 0;
  padding: 0.65rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
}

#silfra-chat-widget-container .xpert-hs-item.is-active {
  background: #f1f7fd;
}

#silfra-chat-widget-container .xpert-hs-meta {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.2rem;
  font-size: var(--fs-xs);
  line-height: 1.2;
}

#silfra-chat-widget-container .xpert-hs-who {
  font-weight: 600;
  color: var(--color-text);
}

#silfra-chat-widget-container .xpert-hs-tag {
  padding: 0.1rem 0.45rem;
  border-radius: 10px;
  background: #e8f1fb;
  color: var(--color-primary-dark);
  font-weight: 600;
  font-size: 10px;
  white-space: nowrap;
}

#silfra-chat-widget-container .xpert-hs-tag--muted {
  background: #f3f4f6;
  color: #6b7280;
}

#silfra-chat-widget-container .xpert-hs-when {
  margin-left: auto;
  color: #94a3b8;
  white-space: nowrap;
}

#silfra-chat-widget-container .xpert-hs-when .dot-loader {
  transform: scale(0.7);
}

#silfra-chat-widget-container .xpert-hs-snippet {
  margin: 0;
  font-size: var(--fs-sm);
  color: #374151;
  line-height: 1.45;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

#silfra-chat-widget-container .xpert-hs-mark {
  padding: 0 1px;
  border-radius: 2px;
  background: #fde68a;
  color: inherit;
}

#silfra-chat-widget-container .xpert-hs-footnote {
  margin: 0.75rem 1rem 0;
  font-size: var(--fs-xs);
  color: #94a3b8;
  text-align: center;
}

/* Message a search jump landed on: brief tint so the eye finds it. */
#silfra-chat-widget-container .xpert-search-hit {
  border-radius: 10px;
  animation: xpert-search-hit 2.5s ease-out;
}

@keyframes xpert-search-hit {
  0%, 35% { background-color: rgba(253, 230, 138, 0.65); box-shadow: 0 0 0 6px rgba(253, 230, 138, 0.65); }
  100%    { background-color: transparent; box-shadow: 0 0 0 6px transparent; }
}

/* Shown while the list is a past slice rather than the live end of the chat. */
#silfra-chat-widget-container .xpert-history-jump-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.45rem 0.75rem 0.45rem 1rem;
  border-top: 1px solid var(--color-border);
  background: #f1f7fd;
  font-size: var(--fs-xs);
  color: #374151;
}

#silfra-chat-widget-container .xpert-history-jump-btn {
  margin: 0;
  padding: 0.3rem 0.75rem;
  border: none;
  border-radius: 14px;
  background: var(--color-primary);
  color: var(--color-text-light);
  font: inherit;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: none;
}

#silfra-chat-widget-container .xpert-history-jump-btn:hover {
  background: var(--color-primary-dark);
}

@media (prefers-reduced-motion: reduce) {
  #silfra-chat-widget-container .xpert-hs-panel,
  #silfra-chat-widget-container .xpert-search-hit {
    animation: none;
  }
  #silfra-chat-widget-container .xpert-search-hit {
    background-color: rgba(253, 230, 138, 0.4);
  }
}
